import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "__barrel_optimize__?names=Skeleton!=!/var/www/askpaul_web/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next-axiom/dist/webVitals/components.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/assets/event/title_ai_insight.png");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBack"] */ "/var/www/askpaul_web/src/app/components/common/HeaderBack.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layout-widgets/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Markets"] */ "/var/www/askpaul_web/src/app/event/[eventName]/components/Markets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Rule"] */ "/var/www/askpaul_web/src/app/event/[eventName]/components/Rule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ViewMore"] */ "/var/www/askpaul_web/src/app/event/[eventName]/components/ViewMore.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/event/[eventName]/index.css");
